import Test from "../../components/Test";
function TestPage() {
  return (
    <div>
      <Test />
    </div>
  );
}

export default TestPage;
